import { FC, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { PublicLoggedInContainerWithNavbar } from 'src/components/organismsLegacy/LoggedInContainer/PublicLoggedInContainerWithNavbar';
import {
  fetchPublicReports,
  setReportJustSubmitted,
} from '../../../creators/OpenReporting.creators';
import * as Types from '../../../types';
import { State, User } from '../../../types';
import PublicReportCard from '../PublicReportCard';

interface LocalProps {
  organisation: string;
  currentUser?: User;
  fetchPublicReports: () => void;
}

type Props = ReturnType<typeof mapStateToProps> & LocalProps;

export const PublicReportsList: FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { currentUser, fetchPublicReports } = props;

  useEffect(() => {
    dispatch(setReportJustSubmitted(false));
  }, [dispatch]);

  useEffect(() => {
    fetchPublicReports();
  }, [currentUser, fetchPublicReports]);
  return (
    <PublicLoggedInContainerWithNavbar
      organisation={props.organisation}
      currentUser={props.currentUser}
      selectedTabIndex={0}
      hideMenusWhenSmall={false}
      hideID={props.publicReports.every(
        (report) => report.source === 'vault-talk',
      )}
    >
      {props.publicReports.map((publicReport) => (
        <PublicReportCard
          key={publicReport.reportId}
          linkToViewReport
          reportId={publicReport.reportId}
          organisation={props.organisation}
          category={publicReport.reportedCategory?.name ?? 'No category chosen'}
          displayId={publicReport.displayId}
          status={publicReport.status}
          created={publicReport.date}
          source={publicReport.source}
        />
      ))}
    </PublicLoggedInContainerWithNavbar>
  );
};

const mapStateToProps = (state: State) => ({
  publicReports: (state.openReporting?.openReportingReducer?.publicReports ||
    []) as Types.Report[],
});

const mapDispatchToProps = { fetchPublicReports };

export default connect(mapStateToProps, mapDispatchToProps)(PublicReportsList);
